import {
  CREATE_NEW_USER,
  LOGIN_USER,
  VALIDATE_USER_TOKEN,
  UPDATE_USER_PROFILE,
  UPDATE_USER_PASSWORD,
} from "../type";
import { useInsertData } from "../../hooks/useInsertData";
import { useUpdateData } from "../../hooks/useUpdateData";
import { useGetDataToken } from "../../hooks/useGetData";

export const createNewUser = (data) => async (dispatch) => {
  try {
    const response = await useInsertData(`/api/v1/users/register`, data);

    dispatch({
      type: CREATE_NEW_USER,
      payload: response,
      loading: true,
    });
  } catch (error) {
    dispatch({
      type: CREATE_NEW_USER,
      payload: error.response,
    });
  }
};

export const loginUser = (data) => async (dispatch) => {
  try {
    const response = await useInsertData(`/api/v1/users/login`, data);

    dispatch({
      type: LOGIN_USER,
      payload: response,
      loading: true,
    });
  } catch (error) {
    dispatch({
      type: LOGIN_USER,
      payload: error.response,
    });
  }
};

/*
 * Validate the current stored token/user against the backend.
 * Resolves to { valid: boolean, user: object|null }.
 * Used at app startup to ensure the localStorage user is real and
 * belongs to this app before treating the session as authenticated.
 */
export const validateUserToken = (id) => async (dispatch) => {
  try {
    const response = await useGetDataToken(`/api/v1/users/refreshUserToken/${id}`);

    // handle user object being returned either directly or wrapped in { data }
    const userData = response && response.data ? response.data : response;

    // A successfully-resolved request means the stored token is still
    // accepted by the backend. The "family" app discriminator is added
    // client-side at login, so we only require the session to be valid
    // here; the app-field check happens in ProtectedRouteHook.
    const valid = true;

    dispatch({
      type: VALIDATE_USER_TOKEN,
      payload: { valid, user: userData },
    });
    return { valid, user: userData };
  } catch (error) {
    // Request threw (e.g. 401 / expired token) -> invalid session
    dispatch({
      type: VALIDATE_USER_TOKEN,
      payload: { valid: false, user: null },
    });
    return { valid: false, user: null };
  }
};

export const updateUserProfile = (id, body) => async (dispatch) => {
  try {
    const response = await useUpdateData(`/api/v1/users/${id}`, body);

    dispatch({
      type: UPDATE_USER_PROFILE,
      payload: response,
      loading: true,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_USER_PROFILE,
      payload: error.response,
    });
  }
};

export const updateUserPassword = (id, body) => async (dispatch) => {
  try {
    const response = await useUpdateData(`/api/v1/users/${id}`, body);

    dispatch({
      type: UPDATE_USER_PASSWORD,
      payload: response,
      loading: true,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_USER_PASSWORD,
      payload: error.response,
    });
  }
};
